import { ReportType } from './report'

export enum ScheduleReportFrequencyType {
  DAILY = 'DAILY',
}

export enum ScheduledReportDateRangePreset {
  PREVIOUS_DIARY_DAY = 'PREVIOUS_DIARY_DAY',
  PREVIOUS_7_DAYS = 'PREVIOUS_7_DAYS',
  PREVIOUS_30_DAYS = 'PREVIOUS_30_DAYS',
  PREVIOUS_WEEK = 'PREVIOUS_WEEK',
}

export const ScheduledReportDateRangePresetName: Record<
  ScheduledReportDateRangePreset,
  string
> = {
  [ScheduledReportDateRangePreset.PREVIOUS_DIARY_DAY]: 'Previous day',
  [ScheduledReportDateRangePreset.PREVIOUS_7_DAYS]: 'Previous 7 days',
  [ScheduledReportDateRangePreset.PREVIOUS_30_DAYS]: 'Previous 30 days',
  [ScheduledReportDateRangePreset.PREVIOUS_WEEK]: 'Previous week (Mon-Sun)',
}

/**
 * @deprecated Use ReportType directly.
 * Kept as a compatibility bridge for legacy callers while scheduled reports
 * migrate to the report module.
 */
export enum ScheduleReportConfigType {
  ADMISSION_GROUPS_SUMMARY = 'TLPRO_RESERVATION_DUMP',
  UPCOMING_EVENT_TICKET_SUMMARY = 'TLPRO_ADMISSION_DUMP',
  DAY_SUMMARY = 'TLPRO_ADMISSION_GROUP_DUMP',
}

/**
 * @deprecated Use ReportTypeName directly.
 */
export enum ScheduleReportConfigTypeNames {
  ADMISSION_GROUPS_SUMMARY = 'Reservations',
  UPCOMING_EVENT_TICKET_SUMMARY = 'Admissions',
  DAY_SUMMARY = 'Admissions/Res',
}

/** Valid Mongo day-of-week indices (0–6). */
export const daysOfTheWeek = [0, 1, 2, 3, 4, 5, 6] as const
export const scheduledReportConfigMaxHour = 23
export const scheduledReportConfigMaxMin = 59
/** Diary “day” boundary for admission-group style reports (generator). */
export const scheduledReportConfigDayStartHour = 8

export const scheduledReportConfigDefaultTimezone = 'America/New_York'

export const scheduledReportConfigValidationErrorMessages = {
  EMAILS_REQUIRED: 'emails is required',
  EMAILS_STRINGS: 'emails must be strings',
  EMAILS_ARRAY: 'emails must be an array',
  EMPTY_UPDATE: 'updates cannot be empty',
  FREQUENCY_TYPE_INVALID: 'frequencyType is invalid',
  FREQUENCY_TYPE_REQUIRED: 'frequencyType is required',
  NAME_REQUIRED: 'name is required',
  NO_UPDATABLE_FIELDS: 'no updatable fields were passed in',
  ORGANIZATION_REQUIRED: 'organization is required',
  REPORT_DAYS_OF_WEEK_ARRAY: 'reportDaysOfWeek must be an array',
  REPORT_DAYS_OF_WEEK_BOUNDS:
    'reportDaysOfWeek elements must be between 0 and 6',
  REPORT_TIME_HOUR_REQUIRED: 'report time hour is required',
  REPORT_TIME_HOUR_INTEGER: 'report time hour must be an integer',
  REPORT_TIME_HOUR_GT_MAX: 'report time hour cannot be greater than 23',
  REPORT_TIME_HOUR_LT_MIN: 'report time hour cannot be less than 0',
  REPORT_TIME_MINUTE_REQUIRED: 'report time minute is required',
  REPORT_TIME_MINUTE_INTEGER: 'report time minute must be an integer',
  REPORT_TIME_MINUTE_GT_MAX: 'report time minute cannot be greater than 59',
  REPORT_TIME_MINUTE_LT_MIN: 'report time minute cannot be less than 0',
  REPORT_TIME_NEXT_INVALID: 'report time next is invalid',
  REPORT_TYPE_INVALID: 'report type is invalid',
  REPORT_TYPE_REQUIRED: 'report type is required',
  STRINGS_REQUIRED: 'strings are required',
  VENUE_REQUIRED: 'venue is required',
  VENUE_ORGANIZATION_REQUIRED: 'venue must be part of an organization',
} as const
